<script lang="ts">
    import {link,push} from 'svelte-spa-router'
    import * as qs from 'qs';
    import * as numeral from 'numeral';
    import Header from './Header.svelte';
    import HeaderThemes from './HeaderThemes.svelte';
    import Footer from './Footer.svelte';
    import FooterThemes from './Footerthemes.svelte';
    import Clipboard from "svelte-clipboard";
    import Fa from 'svelte-fa'
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faSpinner,faCopy,faMoneyBills,faGift } from '@fortawesome/free-solid-svg-icons';
    import Time from "svelte-time";
    import Swal from 'sweetalert2'

    document.body.scrollIntoView();
    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))

    let loading = false
    let bnakDep = {}
    let lldep = true
    let llwith = false
    let names;

    let isList = false
    let hisDepList = []
    let hisWithList = []
    let dateNow = Math.floor(Date.now() / 1000)

    async function gethistory() {
        isList = false
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/gethistorylist", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) { 
            hisDepList = json.payload.deposit
            hisWithList = json.payload.withdraw
            isList = true
            lldep = true
		} else {
            throw new Error(json);
		}
    }
    async function cancelJPay(ids) {
        Swal.fire({
            title: "กรุณายืนยันการยกเลิกรายการ",
            
            showCancelButton: true,
            confirmButtonText: "ยืนยัน",
            }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                cancelJPayCallback(ids)
            }
        });
    }
    async function cancelJPayCallback(ids) {
        isList = false
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/canceljpay", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({id:ids})
        })
        const json = await res.json()
        if (json.statusCode==200) { 
            gethistory()
            Swal.fire("ยกเลิกรายการเรียบร้อยแล้ว", "", "success");
		} else {
            throw new Error(json);
		}
    }
    $: {
        gethistory()
     
    }
    function openWith(){
        lldep = false
        llwith = true
    }
    function openDep(){
        lldep = true
        llwith = false
    }

</script>
<div class="default-home">
<div class="row  mb-5" style="background-image: url('{dataSetting.background}'); background-size:cover; background-repeat: no-repeat; background-position: center top;">
    <Header />
    
   
    <div class="col-12 text-center mt-2" ><h4 class="header-n">ประวัติฝาก-ถอน</h4></div>
    <div class="col-12 text-center" style="">
        <button type="button" class="btn btn-outline-success btn-sm  bg-dk w-49" on:click={() => openDep()} style="width:49%;">ฝาก</button>
        <button type="button" class="btn btn-outline-danger btn-sm  bg-dk w-49" on:click={() => openWith()}  style="width:49%;">ถอน</button>
    </div>
    <div class="col-12" style="min-height: 500px;">
        {#if loading}
        <div class="text-center mt-2" style="">
            <Fa icon={faSpinner} size="3x" pulse class="text-white"/>
        </div>
        {/if}
        {#if !loading}
        <div class="card mt-2 bg-black">
            <div class="card-body text-center text-white">
                {#if isList}

                {#if lldep} 
                {#each hisDepList as gms}
                <div class="shadow-lg rounded p-2 text-center mb-2" style="background: linear-gradient(135deg, rgb(0, 0, 0) 0%, rgb(86, 80, 80) 50%, rgb(131, 120, 120) 51%, rgb(54, 50, 50) 71%, rgb(0, 0, 0) 100%); box-shadow: rgb(0, 0, 0) 5px 5px 10px !important; line-height: 30px; border-radius: 5px; padding: 2px 7px; color: gold;">
                    {#if gms.status=='S'}
                    <span class="text-info">สำเร็จ</span>
                    
                    {:else}
                    <span class="text-white">รอดำเนินการ</span>
                    {/if}
                    <div class="row">
                        {#if gms.bank_code==''}
                        <div class="col-4 text-warning">รายการโบนัส</div>
                        {:else if gms.bank_code=='corepay'}
                        <div class="col-4">
                            ระบบอัตโนมัติ
                            {#if gms.txn != '' && gms.status=='S'}
                            <br />
                            <span class="badge bg-primary" style="line-height: 15px;">{gms.txn}</span>
                            {/if}
                        </div>
                        {:else if gms.bank_code=='ezpay' || gms.bank_code=='spay' || gms.bank_code=='jpay' || gms.bank_code=='gonepay' || gms.bank_code=='p2w' || gms.bank_code=='cubixpay' || gms.bank_code=='gmpay24' || gms.bank_code=='setzero'}
                        <div class="col-4"><img src="./assets/icon/bank/spay.png"  alt="payment" style="border-radius: 10px;max-height:30px;">
                            {#if gms.txn != '' && gms.status=='S'}
                            <br />
                            <span class="badge bg-primary" style="line-height: 15px;">{gms.txn}</span>
                            {/if}
                        </div>
                        {:else}
                        <div class="col-4"><img src="./assets/icon/bank/{gms.bank_code}.png"  alt="promptpay" style="border-radius: 10px;max-height:30px;"><br />{gms.bank_acc}</div>
                        {/if}
                        <div class="col-4">
                            <Fa icon={faMoneyBills} size="sm" /> {Number(gms.transaction_total.toFixed(2)).toLocaleString("en-US")}
                            {#if Number(gms.transaction_bonus)>0}
                            <br />
                            <span class="text-danger"><Fa icon={faGift} size="sm" /> {Number(gms.transaction_bonus.toFixed(2)).toLocaleString("en-US")}</span>
                            {/if}
                        </div>
                        {#if gms.status=='S'}
                        <div class="col-4"><Time timestamp="{gms.update_dtm*1000}" format="DD/MM/YYYY HH:mm:ss" /></div>
                        {:else}
                            {#if gms.bank_code=='gpay'}
                            <div class="col-4"><a  on:click={() => push('/gpay/'+gms.txn)} ><img src="./assets/images/paynow.png"  alt="promptpay" style="max-width:60px;"></a></div>
                            {:else if gms.bank_code=='gpayfp'}
                            <div class="col-4"><a  on:click={() => push('/gpayfp/'+gms.txn)} ><img src="./assets/images/paynow.png"  alt="promptpay" style="max-width:60px;"></a></div>
                            {:else if gms.bank_code=='ezpay'}
                            <div class="col-4"><a  on:click={() => push('/ezpay/'+gms.txn)} ><img src="./assets/images/paynow.png"  alt="promptpay" style="max-width:60px;"></a></div>
                            {:else if gms.bank_code=='p2w'}
                            <div class="col-4"><a  on:click={() => push('/p2w/'+gms.txn)} ><img src="./assets/images/paynow.png"  alt="promptpay" style="max-width:60px;"></a></div>
                            {:else if gms.bank_code=='spay'}
                            <div class="col-4"><a  on:click={() => push('/spay/'+gms.txn)} ><img src="./assets/images/paynow.png"  alt="promptpay" style="max-width:60px;"></a></div>
                            {:else if gms.bank_code=='gmpay24'}
                            <div class="col-4"><a  on:click={() => push('/gmpay24/'+gms.txn)} ><img src="./assets/images/paynow.png"  alt="promptpay" style="max-width:60px;"></a></div>
                            {:else if gms.bank_code=='jpay'}
                                {#if gms.transaction_end >= dateNow}
                                <div class="col-4 p-0">
                                    <a href="{gms.slip_url}" target="_blank" ><img src="./assets/images/paynow.png"  alt="promptpay" style="max-width:50px;"></a>
                                    <a on:click={() => cancelJPay(gms._id)}  ><img src="./assets/images/cancel.png"  alt="promptpay" style="max-width:25px;"></a>
                                </div>
                                {:else}
                                <div class="col-4"><small class="text-danger">Expired</small></div>
                                {/if}

                            {:else}
                            <div class="col-4"><a href="{gms.slip_url}" target="_blank" ><img src="./assets/images/paynow.png"  alt="promptpay" style="max-width:60px;"></a></div>
                            {/if}
                        {/if}
                    </div>
                </div>
                {/each}
                {/if}

                {#if llwith} 
                {#each hisWithList as gms}
                <div class="shadow-lg rounded p-2 text-center mb-2" style="background: linear-gradient(135deg, rgb(0, 0, 0) 0%, rgb(86, 80, 80) 50%, rgb(131, 120, 120) 51%, rgb(54, 50, 50) 71%, rgb(0, 0, 0) 100%); box-shadow: rgb(0, 0, 0) 5px 5px 10px !important; line-height: 30px; border-radius: 5px; padding: 2px 7px; color: gold;">
                    {#if gms.status=='S'}
                    <span class="text-info">สำเร็จ</span>
                    {:else}
                    <span class="text-secondary">รอดำเนินการ</span>
                    {/if}
                    <div class="row">
                        <div class="col-4">{gms.bank_code}<br />{gms.bank_acc}</div>
                        <div class="col-4">{Number(gms.transaction_total.toFixed(2)).toLocaleString("en-US")}</div>
                        <div class="col-4"><Time timestamp="{gms.update_dtm*1000}" format="DD/MM/YYYY HH:mm:ss" /></div>
                    </div>
                </div>
                {/each}
                {/if} 
 
                {/if}
            </div>
        </div>
        {/if}
    </div>
 
</div>
<Footer />
</div>
<div class="themes-home" style="display: none;">
    <div class="row mb-3 blog-settings">
        <HeaderThemes/>
        <div class="col-12 text-center" ><h4 class="head-title">ประวัติ</h4></div>
        <div class="col-12 text-center" style="">
            <button type="button" class="btn btn-outline-success btn-sm  bg-dk w-49" on:click={() => openDep()} style="width:49%;">ฝาก</button>
            <button type="button" class="btn btn-outline-danger btn-sm  bg-dk w-49" on:click={() => openWith()}  style="width:49%;">ถอน</button>
        </div>
        <div class="col-12" style="min-height: 500px;">
            {#if loading}
            <div class="text-center mt-2" style="">
                <Fa icon={faSpinner} size="3x" pulse class="text-white"/>
            </div>
            {/if}
            {#if !loading}
            <div class="card mt-3 bg-black">
                <div class="card-body text-center text-white">
                    {#if isList}
    
                    {#if lldep} 
                    {#each hisDepList as gms}
                    <div class="shadow-lg rounded p-2 text-center mb-2 mini-blog">
                        {#if gms.status=='S'}
                        <span class="text-info">สำเร็จ</span>
                        
                        {:else}
                        <span class="text-white">รอดำเนินการ</span>
                        {/if}
                        <div class="row">
                            {#if gms.bank_code==''}
                            <div class="col-4 text-warning">รายการโบนัส</div>
                            {:else if gms.bank_code=='corepay'}
                            <div class="col-4">
                                ระบบอัตโนมัติ
                                {#if gms.txn != '' && gms.status=='S'}
                                <br />
                                <span class="badge bg-primary" style="line-height: 15px;">{gms.txn}</span>
                                {/if}
                            </div>
                            {:else if gms.bank_code=='gpay' || gms.bank_code=='gpayfp' || gms.bank_code=='spay' || gms.bank_code=='gonepay' || gms.bank_code=='p2w' || gms.bank_code=='cubixpay' || gms.bank_code=='gmpay24' || gms.bank_code=='setzero'}
                            <div class="col-4"><img src="./assets/icon/bank/spay.png"  alt="payment" style="border-radius: 10px;max-height:30px;">
                                {#if gms.txn != '' && gms.status=='S'}
                                <br />
                                <span class="badge bg-primary" style="line-height: 15px;">{gms.txn}</span>
                                {/if}
                            </div>
                            {:else}
                            <div class="col-4"><img src="./assets/icon/bank/{gms.bank_code}.png"  alt="promptpay" style="border-radius: 10px;max-height:30px;"><br />{gms.bank_acc}</div>
                            {/if}
                            <div class="col-4">
                                <Fa icon={faMoneyBills} size="sm" /> {Number(gms.transaction_total.toFixed(2)).toLocaleString("en-US")}
                                {#if Number(gms.transaction_bonus)>0}
                                <br />
                                <span class="text-danger"><Fa icon={faGift} size="sm" /> {Number(gms.transaction_bonus.toFixed(2)).toLocaleString("en-US")}</span>
                                {/if}
                            </div>
                            {#if gms.status=='S'}
                            <div class="col-4"><Time timestamp="{gms.update_dtm*1000}" format="DD/MM/YYYY HH:mm:ss" /></div>
                            {:else}
                               {#if gms.bank_code=='gpay'}
                                <div class="col-4"><a  on:click={() => push('/gpay/'+gms.txn)} class="btn btn-warning btn-xs">ชำระเงิน</a></div>
                                {:else if gms.bank_code=='gpayfp'}
                                <div class="col-4"><a  on:click={() => push('/gpayfp/'+gms.txn)} class="btn btn-warning btn-xs">ชำระเงิน</a></div>
                                {:else if gms.bank_code=='ezpay'}
                                <div class="col-4"><a  on:click={() => push('/ezpay/'+gms.txn)} class="btn btn-warning btn-xs">ชำระเงิน</a></div>
                                {:else if gms.bank_code=='p2w'}
                                <div class="col-4"><a  on:click={() => push('/p2w/'+gms.txn)} class="btn btn-warning btn-xs">ชำระเงิน</a></div>
                                {:else if gms.bank_code=='gmpay24'}
                                <div class="col-4"><a  on:click={() => push('/gmpay24/'+gms.txn)} class="btn btn-warning btn-xs">ชำระเงิน</a></div>
                                {:else}
                                <div class="col-4"><a href="{gms.slip_url}" target="_blank" class="btn btn-warning btn-xs">ชำระเงิน</a></div>
                                {/if}
                            {/if}
                            
                        </div>
                    </div>
                    {/each}
                    {/if}
    
                    {#if llwith} 
                    {#each hisWithList as gms}
                    <div class="shadow-lg rounded p-2 text-center mb-2 mini-blog">
                        {#if gms.status=='S'}
                        <span class="text-info">สำเร็จ</span>
                        {:else}
                        <span class="text-secondary">รอดำเนินการ</span>
                        {/if}
                        <div class="row">
                            <div class="col-4">{gms.bank_code}<br />{gms.bank_acc}</div>
                            <div class="col-4">{Number(gms.transaction_total.toFixed(2)).toLocaleString("en-US")}</div>
                            <div class="col-4"><Time timestamp="{gms.update_dtm*1000}" format="DD/MM/YYYY HH:mm:ss" /></div>
                        </div>
                    </div>
                    {/each}
                    {/if} 
     
                    {/if}
                </div>
            </div>
            {/if}
        </div>
    </div>
</div>
<div class="themes-home-section" style="display: none;display:flex;">
    
</div>
<div class="footer-themes" style="display: none;">
    <FooterThemes />
</div>
<style>
    .btn-gd{
        --bs-btn-padding-y:0.1rem; --bs-btn-padding-x:0.3rem; --bs-btn-font-size:0.8rem;
        font-weight: 300;
    }
    .bg-dk{
        background-color: black;
    }
    .text-sm{
        font-weight: 300;
        font-size: 0.6rem;
    }
    .pointer{
        cursor: pointer;
    }
    .bg-black{
        background: #000000ad !important;
    }
</style>
